import EventParticipantsContainer from './event_participants_container';

const EventParticipants = EventParticipantsContainer;
export default EventParticipants;
